<template>
  <div class="data-panel">
    <h3 class="data-title">Usuários</h3>
    <div v-if="!detail" style="color:#9ca3af;font-size:14px;">Carregando...</div>
    <table v-else class="admin-table">
      <thead>
        <tr>
          <th>Avatar</th>
          <th>Nome</th>
          <th>Usuário</th>
          <th>Cargo</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="u in detail.users" :key="u.username">
          <td>
            <div class="user-avatar">
              <img v-if="u.avatar && (u.avatar.startsWith('data:') || u.avatar.startsWith('/uploads/'))" :src="resolveAvatar(u.avatar)" alt="avatar" />
              <span v-else class="user-avatar-initials">{{ initials(u.name) }}</span>
            </div>
          </td>
          <td>{{ u.name }}</td>
          <td><code>{{ u.username }}</code></td>
          <td><span class="role-badge" :class="roleClass(u.role)">{{ roleLabel(u.role) }}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { inject } from 'vue'

interface User { username: string; name: string; role: string; roleId: string; avatar: string }
interface SystemDetail { users: User[] }

export default {
  name: 'AdminSysUsersTab',
  setup() {
    const detail = inject<any>('adminDetail')
    const apiBase = process.env.VUE_APP_API_BASE || 'http://localhost:3001'

    const initials = (name: string) => (name || '?').split(' ').map((w: string) => w[0]).slice(0, 2).join('').toUpperCase()

    const resolveAvatar = (avatar: string) => {
      if (avatar.startsWith('/uploads/')) return `${apiBase}${avatar}`
      return avatar
    }

    const roleLabel = (role: string) => {
      if (role === 'admin-master') return 'Admin Master'
      if (role === 'admin-obra') return 'Admin Obra'
      return 'Usuário'
    }

    const roleClass = (role: string) => {
      if (role === 'admin-master') return 'role-master'
      if (role === 'admin-obra') return 'role-admin'
      return 'role-user'
    }

    return { detail, initials, resolveAvatar, roleLabel, roleClass }
  }
}
</script>

<style lang="scss">
/* ── Shared admin tab styles (global, non-scoped) ── */
.data-panel { padding: 28px; }
.data-title { font-size: 16px; font-weight: 600; color: #111827; margin: 0 0 14px; }

.admin-table {
  width: 100%;
  border-collapse: collapse;

  th {
    background: #f9fafb;
    padding: 10px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #e5e7eb;
  }

  td {
    padding: 12px 16px;
    font-size: 14px;
    color: #374151;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
  }

  tr:last-child td { border-bottom: none; }
  tr:hover td { background: #f9fafb; }

  code { font-size: 13px; background: #f3f4f6; padding: 2px 6px; border-radius: 4px; }
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;

  img { width: 100%; height: 100%; object-fit: cover; }
}

.user-avatar-initials { font-size: 13px; font-weight: 600; color: #6b7280; }

.role-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 20px;

  &.role-master { background: #fef3c7; color: #92400e; }
  &.role-admin { background: #dbeafe; color: #1e40af; }
  &.role-user { background: #f3f4f6; color: #6b7280; }
}
</style>
